module.exports = __webpack_public_path__ + "assets/lamp.608164f976a5cff5e39ce024ca29fa8f.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/lamp.png
// module id = 115
// module chunks = 0